import React from 'react';

import './negative-margin.scss';
import { makeClassNames } from '../../../utils/styles';

const classNames = () =>
  makeClassNames({
    negativeMargin: 'negative-margin',
  });

/** Adds margin-top: -15px */
const NegativeMargin = () => {
  const cn = classNames();
  return <div className={cn.negativeMargin} />;
};

export default NegativeMargin;
